<template>
  <div>
    <div class="wall-container" ref="container" id="scroll-target" v-bind:class="{ 'wall-expanded': expanded }">
      <div v-if="chevron && expanded" class="justify-center align-center chevron">
        <v-icon class="chevron-icon">mdi-chevron-double-down</v-icon>
      </div>
      <v-card min-height="100%" v-scroll:#scroll-target="onScroll">
        <div class="wall-backdrop" @click="expanded = !expanded">
          <div class="d-flex fill-height justify-center align-center">
            <v-icon class="arrow-icon">mdi-arrow-expand</v-icon>
          </div>
        </div>
        <div>
          <Wall
            internal
            v-bind:activity-id="this.activityId"
            v-bind:expanded="expanded"
            v-bind:hashtag="embedOptions.hashtag"
            v-bind:facebook="embedOptions.fbLink"
            v-bind:twitter="embedOptions.twitterLink"
            v-bind:instagram="embedOptions.instagramLink"
            ref="wall"
          />
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Wall from "../../wall/wall";
import debounce from "../../../util/debounce";
export default {
  name: "ParticipantWall",
  components: { Wall },
  data() {
    return {
      scrollInterval: null,
      expanded: false,
      chevron: false,
    };
  },
  props: {
    embedSrc: String,
    activityId: Number,
  },
  computed: {
    embedOptions() {
      if (this.embedSrc) return JSON.parse(this.embedSrc);
      return {};
    },
  },
  methods: {
    refreshSelfies() {
      this.$refs.wall.getSelfies();
    },
    onScroll(e) {
      if (e.target.scrollTop === e.target.scrollHeight - e.target.offsetHeight) {
        this.chevron = false;
      } else {
        this.chevron = true;
      }
    },
  },
  watch: {
    expanded: {
      handler() {
        if (this.expanded) {
          debounce(() => {
            const scrollHeight = this.$refs.container.scrollHeight;
            const clientHeight = this.$refs.container.clientHeight;
            if (scrollHeight > clientHeight) {
              this.chevron = true;
            } else {
              this.chevron = false;
            }
          }, 500);
        }
      },
    },
  },
  async mounted() {},
  async destroyed() {},
};
</script>

<style scoped lang="scss">
.chevron {
  position: fixed;
  display: flex;
  z-index: 100;
  left: 28.3%;
  top: 90%;
}
.chevron-icon {
  font-size: 5.5em !important;
}
.wall-container {
  position: relative;
  height: 250px;
  transition: all 100ms ease-in-out;
  overflow: hidden;

  .wall-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #30303040;
    cursor: pointer;
    z-index: 10;

    .arrow-icon {
      color: white;
      font-size: 5em;
      margin: 100px auto auto;
    }

    &:hover {
      background-color: #303030c0;
    }
    .headBannerContent {
      display: none !important;
    }
  }
  iframe {
    width: 100%;
    height: 100%;
    scroll-behavior: smooth;
  }

  &.wall-expanded {
    position: fixed;
    width: 60vw;
    height: calc(100vh - 60px);
    top: 60px;
    left: 0;
    overflow-y: scroll !important;
    @media (max-width: 599px) {
      width: 100vw;
    }
    @media (min-width: 1264px) and (min-height: 800px) {
      top: 128px;
      height: calc(100vh - 128px);
    }
    margin: auto;
    z-index: 10;
    .wall-backdrop {
      width: 50px;
      height: 50px;
      right: 0;
      left: auto;
      background-color: #303030c0;
      .arrow-icon {
        font-size: 2em;
        margin-top: auto;
      }
    }
  }
}
</style>
